import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import AppBar from '@mui/material/AppBar';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import Toolbar from '@mui/material/Toolbar';
import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { isModeModalSelector, toggleSidebar } from '../../state';
import MenuHeader from './MenuHeader';
import Favicon from '../../img/favicon.png';

const AppBarStyled = styled(AppBar)(({ theme }) => ({
  zIndex: theme.zIndex.drawer + 1,
  backgroundColor: theme.custom.headerColor,
}));

const StyledDiv = styled('div')(({ theme }) => ({
  flexGrow: 1,
  marginLeft: theme.spacing(1),
}));

const IconButtonRight = styled(IconButton)(({ theme }) => ({
  marginRight: theme.spacing(2),
}));

const BackButtons = () => {
  const isModeModal = useSelector(isModeModalSelector);
  const navigate = useNavigate();
  const handleClick = () => navigate(-1);

  return isModeModal ? (
    <IconButtonRight color="inherit" aria-label="back-button" edge="start" onClick={handleClick}>
      <ArrowBackIcon
        sx={{
          color: theme => theme.palette.primary.main,
        }}
      />
    </IconButtonRight>
  ) : null;
};

const MenuButton = () => {
  const isModeModal = useSelector(isModeModalSelector);
  const dispatch = useDispatch();
  const handleClick = () => dispatch(toggleSidebar());
  return !isModeModal ? (
    <IconButtonRight
      color="inherit"
      aria-label="back-button"
      edge="start"
      onClick={handleClick}
      data-guide="menu-toggle-button"
    >
      <MenuIcon
        sx={{
          color: theme => theme.palette.primary.main,
        }}
      />
    </IconButtonRight>
  ) : null;
};

const Logo = () => {
  const isModeModal = useSelector(isModeModalSelector);
  const { t } = useTranslation();
  return (
    <Box
      component="img"
      sx={!isModeModal ? { height: 35 } : { height: 50 }}
      alt={t('shared.title')}
      src={Favicon}
    />
  );
};

const Header = () => (
  <AppBarStyled position="fixed" enableColorOnDark data-guide="top-header-bar">
    <Toolbar>
      <MenuButton />
      <BackButtons />
      <Logo />
      <Typography
        variant="h6"
        color="text.primary"
        sx={{
          ml: 2,
          fontWeight: 'bold',
        }}
      >
        Conciliations
      </Typography>
      <StyledDiv />
      <MenuHeader />
    </Toolbar>
  </AppBarStyled>
);

export default Header;
